import {useState} from 'react';
import logo from "../img/cover.png";
import reg from "../img/reg.png";
import {auth, provider} from "../firebase";
import { signInWithPopup, createUserWithEmailAndPassword} from "firebase/auth";
import {Link, useHistory} from "react-router-dom";

export default function Register() {

    const history = useHistory();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");

    function handleGoogleAuth(){
        signInWithPopup(auth, provider).then((item) => {
            console.log(item.user);
            alert("Authentication Sucessful 💝")
            history.push('/');
        })
    }

    function handleSubmit(e){
        e.preventDefault();

        createUserWithEmailAndPassword(auth, email, password).then((item) => {
            alert("Registration Successful 💖");
            history.push('/info');
            console.log(item.user);
        }).catch((err) => {
            if(err.code == "auth/email-already-in-use"){
                alert("Email Address Already In Use");
            }
        })
    }
  return (
    <div className='register form'>
        <div className='left'>
            <div className='form-top'>
                <img src={logo} className = "nav-logo"/>
                <h2>Sign up for PrimeMart</h2>
                <button className="google-auth-button" onClick={handleGoogleAuth}><img src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg" alt="Google logo" /><span>Sign in with Google</span></button>
                <p className='or'>or sign up with e-mail</p>
            </div>

            <form onSubmit={handleSubmit}>
                <input type= "email" placeholder='Email Address' value={email} onChange = {e => setEmail(e.target.value)}/>
                <input type= "password" placeholder='Password' value={password} onChange = {e => setPassword(e.target.value)}/>
                <button>Sign Up</button>
            </form>

            <p className='already'>Already a member? <Link to = "/login">Login</Link></p>
        </div>
        <div className='right'><img src = {reg}/></div>
    </div>
  )
}
